export const TYPE_FORMS = {
  fighter_signup_url: 'https://barstool.typeform.com/to/enCM5dgT',
  ring_girl_signup_url: 'https://barstool.typeform.com/to/txplL8n7',
  ring_girl_voting_url: 'https://barstool.typeform.com/to/uivw9Aao'
}
